<div
  class="g-small-model align-items-center d-flex flex-column gap-1 justify-content-center"
>
  <h1
    mat-dialog-title
    *ngIf="_data?.isAlert"
    class="success-dialog-heading text-warning text-center mb-2"
  >
    Alert!
  </h1>
  <h1
    mat-dialog-title
    *ngIf="!_data?.isAlert"
    class="success-dialog-heading text-success text-center mb-2"
  >
    Success
  </h1>
  <mat-dialog-content class="text-center">
    <div class="text-lg font-italic">{{ msg }}</div>
  </mat-dialog-content>
  <div>
      <mat-dialog-actions align="end" class="action-buttons-wrapper">
        <!-- <button mat-stroked-button mat-dialog-close class="g-btn g-tertiary-btn">
      Go to home
    </button> -->
        <button
          mat-flat-button
          *ngIf="_data?.isAlert"
          (click)="close('ok')"
          class="g-btn g-primary-btn"
        >
          OK
        </button>
        <button
          mat-flat-button
          *ngIf="!_data?.okOnly"
          (click)="close('cancel')"
          class="g-btn g-primary-btn"
        >
          {{_data?.isAlert ?  'Cancel' : 'Close'}}
        </button>
      </mat-dialog-actions>
  </div>
</div>
